export default __webpack_public_path__ + "static/media/337.96c14ec6.png";